// extracted by mini-css-extract-plugin
module.exports = {"glassTube":"style_glassTube__2eHFM","glassTube_image":"style_glassTube_image__10Hq_"};